import ReactGA from "react-ga4";

export const initGA = () => {
    ReactGA.initialize("G-685SYMCY7W");
};

export const logPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
};

export const logEvent = (category, action, label) => {
    ReactGA.event({ category, action, label });
};

export const logEventWithValue = (category, action, label,value) => {
  ReactGA.event({ category, action, label,value });
};
